// extracted by mini-css-extract-plugin
export default {"root":"buyer-offers_root__sGNid","offers":"buyer-offers_offers__Ce7vZ"};